<template>
  <!-- 课程顾问 -->
  <div class="container">
    <el-button
      class="mwow-button-filled primary btn-right"
      @click="handleExport"
      :disabled="exporting"
    >
      导出
    </el-button>
    <div>
      <el-table
        :data="tableData"
        size="mini"
        v-horizontal-scroll
        stripe
        style="width: 100%"
        @sort-change="handleSortChange"
        :default-sort="{
          order: 'descending',
          prop: 'order_amount',
        }"
      >
        <el-table-column prop="num" label="排序" width="50"> </el-table-column>
        <el-table-column prop="course_adviser.name" label="课程顾问">
        </el-table-column>
        <el-table-column prop="course_adviser.status" label="当前状态">
          <template slot-scope="scope">
            <div>
              {{ scope.row.course_adviser.status === 1 ? "在职" : "离职" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="date"
          class-name="pp1"
          label="名单数"
          width="100"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            <div class="selfheader">
              <div>名单数</div>
              <el-popover
                placement="top"
                width="200"
                trigger="hover"
                popper-class="followuppopover"
              >
                <p class="tipck">录入的意向学员中，分配给课程顾问的名单数</p>
                <div class="question" slot="reference">
                  <div>?</div>
                </div>
              </el-popover>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.roster_num }}
          </template>
        </el-table-column>
        <el-table-column
          prop="connected_num"
          label="跟进人数"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
        </el-table-column>
        <el-table-column
          prop="new_intention_connected_num"
          label="本月已联络"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
        </el-table-column>
        <el-table-column
          prop="invited_count"
          label="预约体验数"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
        </el-table-column>
        <el-table-column
          prop="visited_num"
          label="到访人数"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
        </el-table-column>
        <el-table-column
          prop="finish_count"
          label="完成体验数"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
        </el-table-column>
        <el-table-column
          prop="transformed_num"
          label="新签学员数"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
        </el-table-column>
        <el-table-column
          prop="order_amount"
          width="130"
          label="新签金额"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
        </el-table-column>
        <el-table-column
          prop="roster_experience_rate"
          label="名单体验率"
          width="120"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.roster_experience_rate }} %</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="visit_experience_rate"
          label="诺访体验率"
          width="120"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.visit_experience_rate }} %</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="experience_transform_rate"
          label="体验转化率"
          width="120"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.experience_transform_rate }} %</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="transformed_proportion"
          label="新签学员数占比"
          class-name="pp1"
          width="130"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            <div class="selfheader">
              <div>新签学员数占比</div>
              <el-popover
                placement="top"
                width="200"
                trigger="hover"
                popper-class="followuppopover"
              >
                <p class="tipck">
                  新签学员数占比 = 课程顾问新签学员数 / 整体新签学员数 * 100%
                </p>
                <div class="question" slot="reference">
                  <div>?</div>
                </div>
              </el-popover>
            </div>
          </template>
          <template slot-scope="scope">
            <div>{{ scope.row.transformed_proportion }} %</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="order_amount_proportion"
          label="新签金额占比"
          class-name="pp1"
          width="130"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            <div class="selfheader">
              <div>新签金额占比</div>
              <el-popover
                placement="top"
                width="200"
                trigger="hover"
                popper-class="followuppopover"
              >
                <p class="tipck">
                  新签金额占比 = 课程顾问新签金额 / 整体新签金额 * 100%
                </p>
                <div class="question" slot="reference">
                  <div>?</div>
                </div>
              </el-popover>
            </div>
          </template>
          <template slot-scope="scope">
            <div>{{ scope.row.order_amount_proportion }} %</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { salesCourseAdviserApi } from "@/api/statistics";
import { dateFormat } from "@/utils/timeFormat";
import json2csv from "json2csv";
import { roundNumbers } from "@/utils/roundNumbers";

export default {
  props: ["data"],
  data() {
    return {
      tableData: [],
      currentSortOption: {
        order: "descending",
        prop: "order_amount",
      },
      paginationData: [],
      s_t: "",
      e_t: "",
      exporting: false,
    };
  },
  watch: {
    data: {
      handler() {
        this.getList();
      },
      immediate: false,
      deep: true,
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const params = {
        start_time: this.data.start_time,
        end_time: this.data.end_time,
      };
      if (this.data.staff_id && this.data.region === 1) {
        params.course_adviser_id = Number(this.data.staff_id);
      }
      if (this.data.studentApp_id && this.data.region === 2) {
        params.appear_id = Number(this.data.studentApp_id);
      }
      if (this.data.source_id && this.data.region === 4) {
        params.source_id = Number(this.data.source_id);
      }
      salesCourseAdviserApi(params).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((it) => {
            it.order_amount = roundNumbers(it.order_amount);
            it.roster_experience_rate = roundNumbers(it.roster_experience_rate);
            it.visit_experience_rate = roundNumbers(it.visit_experience_rate);
            it.experience_transform_rate = roundNumbers(
              it.experience_transform_rate
            );
            it.transformed_proportion = roundNumbers(it.transformed_proportion);
            it.order_amount_proportion = roundNumbers(
              it.order_amount_proportion
            );
          });
          this.tableData = res.data.list;
          this.paginationData = res.data.list;
          this.handleSortChange({
            order: "descending",
            prop: "order_amount",
          });
        }
      });
    },
    handleSortChange(val) {
      this.currentSortOption = {
        order: val.order,
        prop: val.prop,
      };
      this.tableData = this.sortList(this.tableData);
      let n = 0;
      this.tableData.map((it, ind) => {
        n += 1;
        it.num = n;
      });
    },
    sortList(val) {
      const copy = [...val];
      copy.sort((a, b) => {
        return (
          Number(b[this.currentSortOption.prop]) -
          Number(a[this.currentSortOption.prop])
        );
      });
      copy.map((it, ind) => {
        it.ind = ind + 1;
      });
      if (this.currentSortOption.order === "ascending") {
        copy.reverse();
      }
      this.paginationData = copy;
      return copy;
    },
    // 导出
    handleExport() {
      if (this.exporting) {
        return false;
      }
      this.exporting = true;
      const newObj = JSON.parse(JSON.stringify(this.paginationData));
      newObj.map((it) => {
        it.course_adviser.status =
          it.course_adviser.status === 1 ? "在职" : "离职";
      });
      const date = new Date().getTime();
      const dateTime = dateFormat("YYYYmmddHHMMSS", date);
      const endThree = String(date).slice(-3, date.length);
      try {
        const result = json2csv.parse(
          [
            {
              "course_adviser.name": "课程顾问",
              "course_adviser.status": "当前状态",
              roster_num: "名单数",
              connected_num: "跟进人数",
              new_intention_connected_num: "本月已联络",
              invited_count: "预约体验数",
              visited_num: "到访人数",
              finish_count: "完成体验数",
              transformed_num: "新签学员数",
              order_amount: "新签金额",
              roster_experience_rate: "名单体验率",
              visit_experience_rate: "诺访体验率",
              experience_transform_rate: "体验转化率",
              transformed_proportion: "转化占比",
              order_amount_proportion: "金额占比",
            },
            ...newObj,
          ],
          {
            fields: [
              "course_adviser.name",
              "course_adviser.status",
              "roster_num",
              "connected_num",
              "new_intention_connected_num",
              "invited_count",
              "visited_num",
              "finish_count",
              "transformed_num",
              "order_amount",
              "roster_experience_rate",
              "visit_experience_rate",
              "experience_transform_rate",
              "transformed_proportion",
              "order_amount_proportion",
            ],
            header: false,
          }
        );
        // 非IE浏览器
        const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
        // 创建a标签下载
        const link = document.createElement("a");
        link.href = encodeURI(csvContent);
        link.download = "销售综合数据" + dateTime + endThree;
        (".csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // 5秒导出间隔
        setTimeout(() => {
          this.exporting = false;
        }, 5000);
      } catch (err) {
        this.$message({
          type: "error",
          message: err.toString(),
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #ffffff;
  padding: 0 !important;
  border-radius: 4px;
  overflow: visible !important;
  position: relative;
  .btn-right {
    position: absolute;
    right: 10px;
    top: -40px;
    z-index: 999;
  }
}
/deep/.el-table {
  th {
    &.is-sortable {
      .caret-wrapper {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }
      }
    }
  }
}
.selfheader {
  display: flex;
  align-items: center;
  text-align: center;
  .question {
    margin-left: 5px;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #bebfc0;
    text-align: center;
    line-height: 16px;
    opacity: 1;
    color: #fff;
    font-size: 10px;
  }
}
/deep/.pp1 {
  .cell {
    width: 150px !important;
    display: flex !important;
  }
}
</style>
